module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "alt": "",
      "src": "image/DedicationLogo.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Headers",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The College of Our Lady of the Elms")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Chicopee, Massachusetts")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dedicates this Work")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To the Memory of")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Father Hugh Francis Crean, PhD, STD")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("(1937–2015)")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Parish Priest, Professor and College Trustee, Visionary, and Friend")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And to the Members of")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Crean and Andrews Families")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication top1"
  }, [_c('span', {
    staticClass: "Italic CharOverride-2"
  }, [_vm._v("In the face of a true friend, one finds a second self.")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("—Cicero,")]), _c('span', {
    staticClass: "Italic CharOverride-3"
  }, [_vm._v(" De Amititia")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70da45e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlongTheWay_ebook-1.vue
// module id = 60
// module chunks = 0